<template>
  <q-icon
    v-if="isEnabled"
    :name="name"
    :size="size"
    :color="color"
    :left="left"
    :right="right"
    :class="iconClass"
    :style="style"
    :title="title"
    v-bind="$attrs"
  >
    <slot />
  </q-icon>
  <span
    v-else
    class="material-symbols-rounded"
    :class="iconClass"
    :style="style"
    :title="title"
    v-bind="$attrs"
  >
    {{ normalizedIcon }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useFeatureFlags } from "@/composables/useFeatureFlags";

const { isEnabled: checkEnabled } = useFeatureFlags();
const isEnabled = checkEnabled("dtpIcon");
type Props = {
  name?: string;
  size?: string;
  color?: string;
  left?: boolean;
  right?: boolean;
  iconClass?: string;
  style?: string | Record<string, any>;
  title?: string;
};

const props = withDefaults(defineProps<Props>(), {
  name: undefined,
  size: undefined,
  color: undefined,
  left: false,
  right: false,
  iconClass: undefined,
  style: undefined,
  title: undefined
});

const normalizedIcon = computed(() => {
  if (!props.name) return undefined;
  // Remove mdi- prefix if present
  const iconName = props.name.startsWith("mdi-") ? props.name.slice(4) : props.name;

  // Map specific icon names to Material Symbols equivalents
  const iconMap: Record<string, string> = {
    "message-alert": "chat_info",
    "printer": "print",
    "printer-off": "print_off",
    "printer-alert": "print_alert",
    "printer-error": "print_error",
    "printer-warning": "print_warning",
    "printer-info": "print_info",
    "printer-success": "print_success",
    "printer-disabled": "print_disabled",
    "bell": "notifications",
    "account-off": "person_off",
    "pencil": "edit",
    "alert-circle": "warning",
    "calendar-edit": "edit_calendar",
    "human-edit": "person_edit",
    "map-marker": "location_on"
  };

  return iconMap[iconName] || iconName;
});

defineOptions({
  name: "dtpIcon",
  inheritAttrs: true
});
</script>
